import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationCampaign,
  BackendMutationStartContinuousOptimizationCampaignArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation StartCOCampaign($id: ID!) {
    startContinuousOptimizationCampaign(id: $id) {
      id
      status
    }
  }
`;

type Variables = BackendMutationStartContinuousOptimizationCampaignArgs;
type Result = Pick<BackendContinuousOptimizationCampaign, 'id' | 'status'>;

export const startCOCampaign = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
